var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('c-toolbar',{attrs:{"title":"Dashboard"}}),_c('c-form-box',{staticClass:"ma-3",attrs:{"title":"Projects"}},[_c('ProjectsTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }